import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/payroll-engine/_layout/payroll-units/$unitId/')({});